import BottomLineWithLink from "./bottom-line-with-link";
export default BottomLineWithLink;
